"use client";

import { useCallback, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useApiRouter } from "../../hooks/useApiRouter";
import useCountDown from "../../hooks/useCountDown";
import useRequest from "../../hooks/useRequest";
import { Button } from "../ui/button";

/**
 * @typedef {object} Props
 * @prop {() => void} onCodeSent
 * @prop {string} challengeId
 */
/**
 * @param {Props} props
 */
export function TwoFactorAuthChallengeButtonSendCode({
  onCodeSent,
  challengeId,
}) {
  const [codeSent, setCodeSent] = useState(false);

  const { request, loading } = useRequest();

  const { apiRouter } = useApiRouter();

  const countDown = useCountDown();

  const handleClickSendCode = useCallback(() => {
    const url = apiRouter.getUrl({
      id: "@api/user.twoFactorAuthentication.challenge@notify",
      parameters: {
        challengeId,
      },
    });
    request(url, { method: "POST" }).then(
      async ({ response, parsedJson: data }) => {
        if (response?.ok) {
          onCodeSent();
          setCodeSent(true);
          // get the retry-after header
          const retryAfter = Number(
            response?.headers.get("Retry-After") ?? "60",
          );
          countDown.start(retryAfter);
        }
      },
    );
  }, [apiRouter, challengeId, countDown, onCodeSent, request]);

  return (
    <Button
      onClick={handleClickSendCode}
      loading={loading}
      colorPalette="primary"
      disabled={countDown.timeLeft > 0}
      size={codeSent ? "xs" : "md"}
      variant={codeSent ? "outline" : undefined}
      animationName={countDown.timeLeft === 0 ? "pulse2" : undefined}
      animationIterationCount="infinite"
      animationDuration="5s"
      animationDelay="4s"
    >
      {countDown.timeLeft > 0 ? (
        <FormattedMessage
          defaultMessage="Renvoyer le code ({timeLeft} secondes)"
          values={{
            timeLeft: countDown.timeLeft,
          }}
        />
      ) : (
        <FormattedMessage defaultMessage="Recevoir le code" />
      )}
    </Button>
  );
}
